// extracted by css-extract-rspack-plugin
export default {"spinnerSlot":"vSJ9XPJxzT0qnBVL","radios":"ktVWO2PSeRsErlQM","radio":"DIcSbNWsHc4ibHD1","indicator":"yVzQ_9A4q8c4yPho","label":"g6ar5g6s45QBaNOu","items":"LBnSS56VsWUG6NZe"};